<script setup>
import { ProgressBar } from '@claitontech/chap-lib'
</script>

<template>
  <div
    class="position-fixed top-0 start-0 end-0 bottom-0 d-flex justify-content-center align-items-center bg-white"
    style="z-index: 9999"
  >
    <div class="d-flex flex-column align-items-center px-4" style="width: 250px; max-width: 400px">
      <ProgressBar
        :bars="[
          {
            color: 'primary',
            value: 0,
            label: $t('common.loading'),
          },
        ]"
        :small="true"
        :animated="true"
      />
    </div>
  </div>
</template>
